module.exports = __webpack_public_path__ + "img/app-qr2x.9f5dc9e5.png";